import { render } from "./pb-formtraining.vue?vue&type=template&id=3c7f231b"
import script from "./pb-formtraining.vue?vue&type=script&lang=js"
export * from "./pb-formtraining.vue?vue&type=script&lang=js"

import "./pb-formtraining.vue?vue&type=style&index=0&id=3c7f231b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__